module.exports = __webpack_public_path__ + "img/dutyfree_cee8239.svg";